import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./GradeCoursesUIHelpers";

const GradeCoursesUIContext = createContext();

export function useGradeCoursesUIContext() {
  return useContext(GradeCoursesUIContext);
}

export const GradeCoursesUIConsumer = GradeCoursesUIContext.Consumer;

export function GradeCoursesUIProvider({ coursesUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openCourseSubjectListPage: coursesUIEvents.openCourseSubjectListPage,
    openNewGradeCoursePage: coursesUIEvents.openNewGradeCoursePage,
    openEditGradeCoursePage: coursesUIEvents.openEditGradeCoursePage
  };

  return (
    <GradeCoursesUIContext.Provider value={value}>
      {children}
    </GradeCoursesUIContext.Provider>
  );
}